export default function onIntersectionObserve(node, callback) {
  if (!node) { return; }

  const observer = new IntersectionObserver(
    ([entry], _observer) => {
      if (!entry.isIntersecting) { return; }

      // const node = entry.target;
      observer.unobserve(node);

      callback(node);
    }, {
      rootMargin: '40px',
      threshold: [0, 1]
    }
  );
  observer.observe(node);
  $(document).one('turbolinks:before-cache', () => observer.unobserve(node));
}
